import { designAr } from './design.ar.js';
import { familyAr } from './family.ar.js';
import { foodAr } from './food.ar.js';
import { kamersAr } from './kamers.ar.js';
import { kioskBoardAr } from './kioskBoard.ar.js';
import { kioskPrivacyAr } from './kioskPrivacy.ar.js';
import { kioskMoveAr } from './kioskMove.ar.js';
import { readAloudAr } from './readAloud.ar.js';
import { todoAr } from './todo.ar.js';
import { kioskWeatherAr } from './kioskWeather.ar.js';
import { kioskTimerAr } from './kioskTimer.ar.js';
import { hallwayAr } from './hallway.ar.js';
import { kioskRemindersAr } from './reminders.ar.js';
// Arabisch (ar): teksten van het bord (zelfde vorm als nl.ts). Eenvoudig Standaardarabisch;
// AMUMIN in Latijns schrift, getallen Latijns (de cijferkeuze van het gezin doet de rest).
// Weekdagen en maanden staan er expliciet, gelijk aan wat Intl('ar') geeft (يناير … ديسمبر), zodat
// ook een oude iPad zonder Arabische Intl-gegevens Arabische namen toont.
// Sleutels die in nl.ts zelf staan (common, kiosk, web, …) horen hier; de rest in het eigen
// domeinbestand (design.ar.ts, food.ar.ts, …).
export const ar = {
    weekdays: ['الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت', 'الأحد'],
    weekdaysShort: ['الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت', 'الأحد'],
    months: [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر',
    ],
    monthsShort: [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر',
    ],
    design: designAr,
    food: foodAr,
    family: familyAr,
    kamers: kamersAr,
    reminders: kioskRemindersAr,
    weather: kioskWeatherAr,
    // Timer op het bord (oprichter 1 okt 2026).
    timer: kioskTimerAr,
    // Golf 6b (0043): het bord in de gang van een gedeelde woning (hallway.ar.ts).
    hallway: hallwayAr,
    // 0036: melding "Dit bord stopt op ..." (golf 4).
    privacy: kioskPrivacyAr,
    move: kioskMoveAr,
    readAloud: readAloudAr,
    // 0058: to-do's onder de taken van een lid (todo.ar.ts).
    todo: todoAr,
    common: {
        adjustBoard: 'تعديل',
        refreshBoard: 'تحديث',
        create: 'إنشاء جديد',
        agendaBoard: 'التقويم',
        today: 'اليوم',
        tomorrow: 'غدًا',
        now: 'الآن',
        later: 'بعد قليل',
        done: 'تم',
        cancel: 'إلغاء',
        confirm: 'تأكيد',
        back: 'رجوع',
        close: 'إغلاق',
    },
    kiosk: {
        ...kioskBoardAr,
        // 0035: gepauzeerd door AMUMIN Beheer (golf 4).
        paused: 'للعرض فقط',
        pausedHint: 'اللوحة للعرض فقط الآن. يمكنك وضع العلامات لاحقًا.',
        agenda: 'الأجندة',
        tasks: 'المهام',
        rewards: 'المكافآت',
        nothingToday: 'لا شيء مخطط اليوم',
        nothingMore: 'لا شيء بعد الآن اليوم',
        noTasks: 'لا مهام اليوم',
        allDone: 'انتهى كل شيء!',
        /** Rustig, buiten het thema Kinderen. */
        allDoneCalm: 'اكتمل كل شيء',
        allDay: 'طوال اليوم',
        everyone: 'الجميع',
        next: 'بعد ذلك',
        startsIn: 'بعد {time}',
        busyFor: 'باقي {time}',
        minutesShort: '{count} د',
        hoursShort: '{h} س {m} د',
        tasksProgress: '{done} من {total} تمّت',
        pairTitle: 'اربط هذا الجهاز اللوحي',
        pairHint: 'أدخل هذا الرمز في هاتفك:',
        pairScan: 'أو امسح رمز QR بهاتفك',
        pairWaiting: 'في انتظار الموافقة…',
        pairStarting: 'جارٍ جلب الرمز…',
        pairExpired: 'انتهت صلاحية الرمز، جارٍ جلب رمز جديد…',
        pairNoConnection: 'لا اتصال بالخادم، نحاول من جديد…',
        pairQrClaiming: 'جارٍ الربط برمز QR…',
        pairQrInvalid: 'انتهت صلاحية رمز QR هذا أو استُخدم من قبل. أنشئوا رمزًا جديدًا في تطبيق الوالدين، أو اربطوا بالرمز الظاهر على هذه الشاشة.',
        pairQrLimit: 'لا يتسع اشتراككم لجهاز لوحي آخر. افصلوا جهازًا لوحيًا آخر في تطبيق الوالدين أولًا.',
        pairQrBusy: 'محاولات كثيرة قليلًا. انتظروا دقيقة، ثم امسحوا رمز QR مرة أخرى.',
        pairQrOffline: 'لا يوجد اتصال، لذلك لم يعمل رمز QR. امسحوه مرة أخرى، أو اربطوا بالرمز الظاهر على هذه الشاشة.',
        offline: 'لا يوجد اتصال، آخر تحديث الساعة {time}',
        offlineBadge: 'لا يوجد اتصال',
        renderFailed: 'لا تستطيع اللوحة عرض الأجندة الآن، وستحاول مرة أخرى.',
        checkInApp: 'تحقّق من هذا الجهاز اللوحي في تطبيق الوالدين',
        staleData: 'لا توجد بيانات حديثة',
        standaloneTitle: 'أضف لوحة العائلة إلى الشاشة الرئيسية',
        standaloneBody: 'في Safari اضغط على «مشاركة» ثم على «إضافة إلى الشاشة الرئيسية». بعد ذلك افتح اللوحة من تلك الأيقونة، وإلا فلن يُحفظ الربط.',
        points: {
            zero: '{count} نقطة',
            one: 'نقطة واحدة',
            two: 'نقطتان',
            few: '{count} نقاط',
            many: '{count} نقطة',
            other: '{count} نقطة',
        },
        tasksLeft: {
            zero: 'لا مهام باقية',
            one: 'باقية مهمة واحدة',
            two: 'باقية مهمتان',
            few: 'باقية {count} مهام',
            many: 'باقية {count} مهمة',
            other: 'باقية {count} مهمة',
        },
    },
    web: {
        // 0035: gepauzeerd door AMUMIN Beheer (423 household_paused).
        householdPaused: 'لوحة عائلتك للعرض فقط حاليًا. لا يمكن إجراء تغييرات.',
        appName: 'AMUMIN Family Board',
        loginTitle: 'تسجيل الدخول',
        email: 'البريد الإلكتروني',
        password: 'كلمة المرور',
        login: 'تسجيل الدخول',
        forgotPassword: 'نسيت كلمة المرور؟',
        noAccount: 'ليس لديك حساب بعد؟',
        register: 'إنشاء حساب',
        save: 'حفظ',
        add: 'إضافة',
        edit: 'تعديل',
        remove: 'حذف',
        loading: 'جارٍ التحميل…',
        retry: 'حاول مرة أخرى',
        close: 'إغلاق',
        reload: 'إعادة التحميل',
        none: 'لا شيء',
        errorGeneric: 'حدث خطأ ما. حاول مرة أخرى.',
        errorNetwork: 'لا يوجد اتصال بالخادم.',
        errorNotFound: 'هذه الصفحة غير موجودة.',
        moduleOff: 'هذا القسم مطفأ لعائلتكم.',
        /** 0023/0043: dit lid geeft zelf toestemming (consent_self_required). */
        consentSelfRequired: 'من عمره 16 سنة أو أكثر يعطي الموافقة على ذلك بنفسه. تحقق من الأعمار في قسم الأفراد ثم حاول مرة أخرى.',
        versionConflict: 'غيّر شخص آخر هذا في هذه الأثناء. أُعيد تحميل القائمة؛ حاول مرة أخرى.',
        rateLimited: 'محاولات كثيرة جدًا. حاول مرة أخرى بعد {seconds} ثانية.',
        sessionExpired: 'انتهت جلستك. سجّل الدخول من جديد.',
        nav: {
            today: 'اليوم',
            agenda: 'الأجندة',
            members: 'الأفراد',
            devices: 'الأجهزة',
            security: 'الأمان',
            household: 'البيت',
            logout: 'تسجيل الخروج',
        },
        timeInAmsterdam: 'الوقت في أمستردام',
        browserZoneDiffers: 'متصفحك في منطقة زمنية أخرى؛ كل الأوقات هنا بتوقيت أمستردام.',
        householdSwitch: 'البيت النشط',
        sharedComputer: 'حاسوب مشترك أو عام',
        sharedComputerHint: 'تنتهي جلستك بعد 24 ساعة ولن نثق بهذا المتصفح.',
        stayLoggedIn: 'ابقَ مسجّل الدخول',
        invalidCredentials: 'البريد الإلكتروني أو كلمة المرور غير صحيح.',
        emailNotVerified: 'أكّد بريدك الإلكتروني أولًا عبر الرابط في الرسالة.',
        outsideTrustedNetwork: 'أنت خارج شبكة موثوقة. سجّل الدخول من جديد بكلمة المرور ورمز من البريد الإلكتروني.',
        forgetToLogout: 'لا تنسَ تسجيل الخروج عندما تنتهي.',
        lockedOut: 'محاولات فاشلة كثيرة جدًا. حاول لاحقًا.',
        codeTitle: 'رمز البريد الإلكتروني',
        codeIntro: 'أرسلنا رمزًا من 6 أرقام إلى {email}. صالح لمدة 10 دقائق.',
        codeLabel: 'الرمز من الرسالة',
        codeInvalid: 'أدخل الأرقام الستة من الرسالة.',
        codeWrong: 'هذا الرمز غير صحيح. المحاولات الباقية: {count}.',
        codeWrongPlain: 'هذا الرمز غير صحيح.',
        codeLocked: 'رموز خاطئة كثيرة جدًا. سجّل الدخول من جديد لتحصل على رمز جديد.',
        codeExpired: 'انتهت صلاحية الرمز. سجّل الدخول من جديد لتحصل على رمز جديد.',
        trustBrowser: 'ثق بهذا المتصفح 30 يومًا',
        trustBrowserHint: 'حتى {date} لن نطلب رمز البريد الإلكتروني في هذا المتصفح.',
        resend: 'إرسال الرمز من جديد',
        resendIn: 'يمكن الإرسال من جديد بعد {seconds} ث',
        resent: 'أُرسل رمز جديد؛ الرمز السابق لم يعد صالحًا.',
        notMeLink: 'لم يكن هذا أنا',
        noPendingCode: 'لا توجد محاولة دخول مفتوحة. سجّل الدخول أولًا.',
        networkConfirmIntro: 'أكّد الشبكة الموثوقة الجديدة بالرمز المكوّن من 6 أرقام الذي أرسلناه إلى {email}.',
        registerTitle: 'إنشاء حساب',
        passwordHint: '12 حرفًا على الأقل.',
        passwordTooShort: 'استخدم 12 حرفًا على الأقل.',
        passwordTooLong: 'استخدم 256 حرفًا على الأكثر.',
        emailInvalid: 'تحقّق من بريدك الإلكتروني.',
        passwordRepeat: 'أعد كتابة كلمة المرور',
        passwordMismatch: 'كلمتا المرور غير متطابقتين.',
        registerDone: 'تحقّق من بريدك الإلكتروني',
        registerDoneText: 'أرسلنا رابط تأكيد إلى {email}. اضغط عليه لتفعيل حسابك.',
        alreadyAccount: 'لديك حساب بالفعل؟',
        emailTaken: 'يوجد بالفعل حساب بهذا البريد الإلكتروني.',
        passwordBreached: 'كلمة المرور هذه ظهرت في تسريب بيانات. اختر كلمة مرور أخرى.',
        privateEmailHint: 'نصيحة: استخدم بريدًا إلكترونيًا شخصيًا، لا بريد العمل.',
        verifyTitle: 'تأكيد البريد الإلكتروني',
        verifyIntro: 'اضغط على الزر لتأكيد بريدك الإلكتروني.',
        verifyButton: 'تأكيد',
        verifying: 'جارٍ التأكيد…',
        verifyDone: 'تم تأكيد بريدك الإلكتروني. يمكنك الآن تسجيل الدخول.',
        verifyInvalid: 'هذا الرابط غير صالح أو منتهي الصلاحية.',
        tokenMissing: 'هذا الرابط غير مكتمل. افتح الرابط من الرسالة مرة أخرى.',
        toLogin: 'إلى تسجيل الدخول',
        resetTitle: 'نسيت كلمة المرور',
        resetIntro: 'أدخل بريدك الإلكتروني. إذا كان هناك حساب، نرسل رابطًا لتغيير كلمة المرور (صالح 60 دقيقة).',
        resetSend: 'إرسال الرابط',
        resetSent: 'إذا كان هناك حساب بـ {email}، فالرسالة في الطريق.',
        resetConfirmTitle: 'كلمة مرور جديدة',
        newPassword: 'كلمة المرور الجديدة',
        resetConfirmButton: 'تغيير كلمة المرور',
        resetDone: 'تم تغيير كلمة المرور. نُسيت كل المتصفحات الموثوقة؛ في الدخول القادم نطلب رمز البريد الإلكتروني من جديد.',
        resetInvalid: 'رابط إعادة التعيين هذا غير صالح أو منتهي الصلاحية.',
        notMeTitle: 'لم يكن هذا أنا',
        notMeIntro: 'حاول أحدهم تسجيل الدخول بكلمة مرورك. ألم يكن هذا أنت؟ إذن نقفل حسابك.',
        notMeWhatHappens: 'ماذا يحدث عندما تضغط على الزر:',
        notMeStep1: 'تُحظر محاولة الدخول المفتوحة.',
        notMeStep2: {
            zero: 'لا متصفحات موثوقة لنسيانها.',
            one: 'سيُنسى متصفح موثوق واحد.',
            two: 'سيُنسى متصفحان موثوقان.',
            few: 'ستُنسى {count} متصفحات موثوقة.',
            many: 'سيُنسى {count} متصفحًا موثوقًا.',
            other: 'سيُنسى {count} متصفح موثوق.',
        },
        notMeStep2Unknown: 'ستُنسى كل المتصفحات الموثوقة.',
        notMeStep3: {
            zero: 'لا رموز دخول مفتوحة.',
            one: 'سيصبح رمز دخول مفتوح واحد غير صالح.',
            two: 'سيصبح رمزا دخول مفتوحان غير صالحين.',
            few: 'ستصبح {count} رموز دخول مفتوحة غير صالحة.',
            many: 'سيصبح {count} رمز دخول مفتوحًا غير صالح.',
            other: 'سيصبح {count} رمز دخول مفتوح غير صالح.',
        },
        notMeStep4: 'ستصلك رسالة لاختيار كلمة مرور جديدة.',
        notMeButton: 'نعم، لم يكن هذا أنا',
        notMeDone: 'تم. تحقّق من بريدك الإلكتروني لتجد رابط اختيار كلمة مرور جديدة.',
        notMeInvalid: 'هذا الرابط غير صالح أو استُخدم من قبل.',
        stepUpTitle: 'أكّد بكلمة المرور',
        stepUpIntro: 'لهذا الإجراء نطلب كلمة المرور من جديد، حتى في البيت. يسري ذلك 10 دقائق.',
        stepUpButton: 'تأكيد',
        stepUpWrong: 'كلمة المرور غير صحيحة.',
        stepUpCancelled: 'أُلغي الإجراء.',
        wizardTitle: 'إعداد بيتك',
        wizardIntro: 'بعض الأشياء للبداية؛ يمكن تعديل كل شيء لاحقًا.',
        wizardHouseholdName: 'اسم البيت',
        wizardHouseholdHint: 'يظهر في أعلى اللوحة، مثلًا «عائلة الأحمد».',
        wizardYou: 'اسمك على اللوحة',
        wizardPinTitle: 'رمز الوالدين (PIN)',
        wizardPinPlaceholder: 'قريبًا: رمز PIN لوضع الوالدين على الجهاز اللوحي تضبطه هنا بعد تأكيد كلمة المرور.',
        wizardInviteTitle: 'دعوة الوالد الثاني',
        wizardInvitePlaceholder: 'قريبًا: الدعوة بالبريد الإلكتروني؛ يحصل الآخر على الصلاحيات نفسها في هذا البيت.',
        wizardTrustTitle: 'الثقة بهذه الشبكة',
        wizardTrustHint: 'اضبط ذلك في الأمان: عندها لا نطلب رمز البريد الإلكتروني في البيت.',
        wizardSaved: 'تم حفظ البيت.',
        householdNameRequired: 'اكتب اسمًا.',
        todayTitle: 'اليوم',
        todayEmpty: 'لا شيء مخطط اليوم.',
        tasksTitle: 'المهام',
        tasksEmpty: 'لا مهام اليوم.',
        allDay: 'طوال اليوم',
        everyone: 'الجميع',
        doneBy: 'تمّت',
        quickAdd: 'إضافة سريعة',
        agendaTitle: 'الأجندة',
        newEvent: 'موعد سريع',
        newTask: 'مهمة سريعة',
        title: 'العنوان',
        date: 'التاريخ',
        start: 'البداية',
        duration: 'المدة (بالدقائق)',
        forWhom: 'لمن',
        allDayLabel: 'طوال اليوم',
        icon: 'الأيقونة',
        iconNone: 'بلا أيقونة',
        location: 'المكان',
        createEvent: 'إضافة موعد',
        createTask: 'إضافة مهمة',
        eventCreated: 'أُضيف الموعد.',
        taskCreated: 'أُضيفت المهمة.',
        titleRequired: 'اكتب عنوانًا.',
        titleTooLong: '120 حرفًا على الأكثر.',
        dateInvalid: 'اختر تاريخًا صحيحًا (YYYY-MM-DD).',
        memberRequired: 'اختر فردًا واحدًا على الأقل.',
        startInvalid: 'اختر وقت البداية (HH:MM).',
        durationInvalid: 'المدة من 5 إلى 1440 دقيقة.',
        listFor: 'الأجندة ليوم {date}',
        showDay: 'عرض',
        deleteEvent: 'حذف الموعد',
        deleteTask: 'حذف المهمة',
        itemDeleted: 'تم الحذف.',
        noEventsDay: 'لا مواعيد في هذا اليوم.',
        noTasksDay: 'لا مهام في هذا اليوم.',
        membersTitle: 'الأفراد',
        membersIntro: 'كل من يظهر على اللوحة، بحساب أو بدون.',
        addMember: 'إضافة فرد',
        editMember: 'تعديل الفرد',
        memberName: 'الاسم',
        memberKind: 'النوع',
        kindAdult: 'بالغ',
        kindChild: 'طفل',
        kindHelper: 'مساعد',
        color: 'اللون',
        avatarIcon: 'الصورة الرمزية',
        ageBand: 'الفئة العمرية',
        ageBandNone: 'غير محددة',
        nameRequired: 'اكتب اسمًا.',
        nameTooLong: '40 حرفًا على الأكثر.',
        memberSaved: 'تم حفظ الفرد.',
        colorNames: {
            orange: 'برتقالي',
            skyblue: 'أزرق سماوي',
            bluishgreen: 'أخضر مزرق',
            yellow: 'أصفر',
            blue: 'أزرق',
            vermillion: 'قرمزي',
            reddishpurple: 'أرجواني محمر',
            black: 'أسود',
        },
        devicesTitle: 'الأجهزة',
        devicesEmpty: 'لا جهاز لوحي مربوط بعد.',
        pairDevice: 'ربط',
        deviceName: 'الاسم',
        room: 'الغرفة',
        status: 'الحالة',
        lastSeen: 'آخر ظهور',
        lastSync: 'آخر مزامنة',
        statusActive: 'نشط',
        statusRevoked: 'مسحوب',
        statusSuspect: 'مشبوه',
        online: 'متصل',
        offline: 'غير متصل',
        never: 'أبدًا',
        justNow: 'الآن',
        minutesAgo: {
            zero: 'منذ {count} دقيقة',
            one: 'منذ دقيقة',
            two: 'منذ دقيقتين',
            few: 'منذ {count} دقائق',
            many: 'منذ {count} دقيقة',
            other: 'منذ {count} دقيقة',
        },
        hoursAgo: {
            zero: 'منذ {count} ساعة',
            one: 'منذ ساعة',
            two: 'منذ ساعتين',
            few: 'منذ {count} ساعات',
            many: 'منذ {count} ساعة',
            other: 'منذ {count} ساعة',
        },
        daysAgo: {
            zero: 'منذ {count} يوم',
            one: 'منذ يوم',
            two: 'منذ يومين',
            few: 'منذ {count} أيام',
            many: 'منذ {count} يومًا',
            other: 'منذ {count} يوم',
        },
        rename: 'إعادة التسمية',
        revoke: 'سحب',
        revokeConfirm: 'هل أنت متأكد أنك تريد سحب «{name}»؟ سيعرض الجهاز اللوحي شاشة الربط خلال دقيقة.',
        revokeYes: 'نعم، اسحبه',
        deviceRevoked: 'تم سحب الجهاز.',
        deviceSaved: 'تم حفظ الجهاز.',
        appVersion: 'الإصدار',
        standalone: 'تطبيق الشاشة الرئيسية',
        swState: 'Service worker',
        storageOk: 'التخزين',
        clockOffset: 'فرق الساعة',
        pairTitle: 'ربط جهاز لوحي',
        pairIntro: 'أدخل الرمز الذي يعرضه الجهاز اللوحي.',
        pairCode: 'الرمز',
        pairReviewIntro: 'تحقق من الرمز على جهازك اللوحي، ثم اختر الاسم والغرفة.',
        pairConnect: 'ربط هذا الجهاز اللوحي',
        pairMatch: 'هل يطابق هذا الرمز الرمز الظاهر على جهازك اللوحي؟',
        pairChangeCode: 'إدخال رمز آخر',
        pairDetails: 'تفاصيل الجهاز',
        pairNameLabel: 'اسم الجهاز اللوحي',
        pairNameHint: 'يمكنك تغيير هذا الاسم لاحقًا.',
        pairNext: 'ارجع إلى جهازك اللوحي. ستفتح اللوحة عليه تلقائيًا.',
        pairCodeInvalid: 'الرمز من 8 خانات، مثلًا 1234-5678.',
        pairLookup: 'التحقق من الرمز',
        pairNotFound: 'رمز غير معروف أو منتهي الصلاحية. تحقّق من الرمز على الجهاز اللوحي.',
        pairTooMany: 'رموز خاطئة كثيرة جدًا في هذه الجلسة. سجّل الدخول من جديد.',
        pairUserAgent: 'المتصفح',
        pairPlatform: 'النظام',
        pairCountry: 'البلد',
        pairStarted: 'بدأ',
        pairUnknown: 'غير معروف',
        pairApprove: 'موافقة',
        pairApproved: 'رُبط الجهاز اللوحي «{name}». ستظهر اللوحة خلال ثوانٍ.',
        roomRequired: 'اختر غرفة.',
        toDevices: 'إلى الأجهزة',
        securityTitle: 'الأمان',
        trustedNetworksTitle: 'الشبكات الموثوقة',
        trustedNetworksIntro: 'في شبكة موثوقة لا نطلب رمز البريد الإلكتروني؛ كلمة المرور مطلوبة دائمًا.',
        trustThisNetwork: 'الثقة بهذه الشبكة',
        trustServerWan: 'الثقة بعنوان الإنترنت للخادم',
        currentPrefix: 'أنت الآن على {prefix}',
        serverWanLabel: 'عنوان الإنترنت للخادم: {ip}',
        currentPrefixUnknown: 'عنوان الإنترنت الخاص بك غير معروف.',
        networkNoSuggestion: 'لا يمكن إضافة هذه الشبكة كشبكة موثوقة (مثلًا شبكة محلية أو شبكة مزوّد مشتركة).',
        networkAlreadyTrusted: 'هذه الشبكة موثوقة بالفعل.',
        addNetwork: 'إضافة شبكة',
        label: 'التسمية',
        labelRequired: 'اكتب تسمية.',
        kind: 'النوع',
        kindCidr: 'شبكة (CIDR، مثلًا 192.168.1.0/24)',
        kindIp: 'عنوان واحد (IPv4)',
        kindServerWan: 'عنوان الإنترنت للخادم (يُتابَع تلقائيًا)',
        kindDdns: 'اسم مضيف DDNS',
        value: 'القيمة',
        valueInvalid: 'قيمة غير صالحة لهذا النوع من الشبكات.',
        valueIpv6: 'IPv6 غير مدعوم بعد.',
        valueCgnat: 'هذا العنوان تابع لشبكة مزوّد مشتركة (CGNAT) ولا يمكن الوثوق به.',
        scope: 'يسري على',
        scopeHousehold: 'البيت كله',
        scopeIdentity: 'أنا فقط',
        rememberDefault: '«ابقَ مسجّل الدخول» مفعّل في الأصل على هذه الشبكة',
        officeWarning: 'كل من خلف هذا العنوان يتخطى التحقق بالبريد الإلكتروني — هل هذا عنوان عمل ثابت؟',
        mobileHint: 'على الهاتف أو 4G؟ استخدم بدلًا من ذلك «ثق بهذا المتصفح 30 يومًا» عند تسجيل الدخول.',
        networkCreated: 'أُضيفت الشبكة. أكّدها برمز البريد الإلكتروني.',
        networkConfirmed: 'تم تأكيد الشبكة. على هذه الشبكة لن نطلب رمز البريد الإلكتروني بعد الآن.',
        unconfirmed: 'لم تُؤكَّد بعد',
        confirmedAt: 'أُكّدت',
        lastMatched: 'آخر تطابق',
        disabledLabel: 'مطفأ',
        enabledLabel: 'مفعّل',
        disable: 'إيقاف',
        enable: 'تشغيل',
        thisNetwork: 'هذه الشبكة',
        noNetworks: 'لا شبكات موثوقة بعد.',
        trustedBrowsersTitle: 'المتصفحات الموثوقة',
        trustedBrowsersIntro: 'بعد كلمة المرور ورمز البريد الإلكتروني نثق بالمتصفح 30 يومًا؛ بعد ذلك نطلب رمزًا من جديد.',
        thisBrowser: 'هذا المتصفح',
        issued: 'صدر',
        trustedUntil: 'موثوق حتى {date}',
        lastUsedAt: 'آخر استخدام {when}',
        expiresOn: 'ينتهي {date}',
        todayAt: 'اليوم {time}',
        yesterdayAt: 'أمس {time}',
        expires: 'ينتهي',
        lastUsed: 'آخر استخدام',
        forget: 'نسيان',
        forgetOthers: 'نسيان كل المتصفحات الأخرى',
        noTrustedBrowsers: 'لا متصفحات موثوقة.',
        browserForgotten: 'تم نسيان المتصفح.',
        sessionsTitle: 'الجلسات',
        routeLabel: 'الطريقة',
        routeBrowser: 'متصفح موثوق',
        routeNetwork: 'شبكة موثوقة',
        routeOnce: 'مرة واحدة (24 ساعة)',
        routeNone: 'لا شيء',
        thisSession: 'هذه الجلسة',
        revokeSession: 'سحب',
        logoutEverywhere: 'تسجيل الخروج من كل مكان',
        logoutForget: 'تسجيل الخروج ونسيان هذا المتصفح',
        sessionRevoked: 'تم سحب الجلسة.',
    },
};
//# sourceMappingURL=ar.js.map